import { ProposalSlidesType, ProposalTypeOfVisit } from "./types";

export const defaultResumenFields = {
  estimatedLiters: "0",
  estimatedFreeLiters: "0",
  discount: "0",
  rappel: "0",
  noChargeProducts: "0",
  loanImport: "0",
  loanLiters: "0",
  loanMonth: "0",
  adsMonth: "0",
  adsImport: "0",
  adsLiters: "0",
  marketingSupport: "0",
  pointOfSaleSupport: "0",
  plvSupport: "0",
  specialDecoration: "0",
  notes: "",
};

export type SlideBlockKey =
  | "volumes"
  | "photo_success"
  | "catalog"
  | "product_card"
  | "waters"
  | "nexho"
  | "plusbar"
  | "plusbar_sport"
  | "financial"
  | "sustainability"
  | "fieldmarketing"
  | "commercial_conditions";

const includesAny = (haystack: string, needles: string[]) =>
  needles.some((n) => haystack.includes(n));

// Matching to Proposals type of visit
export const matchContentBlock = (
  slide: Pick<ProposalSlidesType, "nameKey" | "type">,
): SlideBlockKey => {
  const nameKey = slide.nameKey ?? "";
  const type = (slide.type ?? "").toLowerCase();

  if (nameKey === "volumes_summary" || nameKey === "contract") return "volumes";
  if (nameKey === "assortment_exito") return "photo_success";
  if (nameKey === "product") return "product_card";
  if (nameKey === "commercial_conditions" || nameKey === "special_offer")
    return "commercial_conditions";
  if (nameKey === "materials") return "fieldmarketing";

  if (includesAny(type, ["nexho", "rentabilibar"])) return "nexho";
  if (includesAny(type, ["laliga", "la liga", "plusbar_sport", "sport"]))
    return "plusbar_sport";
  if (includesAny(type, ["plusbar", "+bar"])) return "plusbar";
  if (includesAny(type, ["water", "agua"])) return "waters";
  if (includesAny(type, ["catalog", "catalogo"])) return "catalog";
  if (includesAny(type, ["financ", "soluciones"])) return "financial";
  if (includesAny(type, ["sostenib", "sustainab"])) return "sustainability";

  return "fieldmarketing";
};

export const typeOfVisitCorrespondance: Record<
  ProposalTypeOfVisit,
  SlideBlockKey[] | null
> = {
  [ProposalTypeOfVisit.Default]: null,
  // Captacion
  [ProposalTypeOfVisit.ClientAcquisition]: [
    "catalog",
    "product_card",
    "waters",
    "nexho",
    "plusbar",
    "plusbar_sport",
    "financial",
    "sustainability",
    "fieldmarketing",
    "commercial_conditions",
  ],
  // Desarollo
  [ProposalTypeOfVisit.BusinessDevelopment]: [
    "volumes",
    "photo_success",
    "product_card",
    "nexho",
    "plusbar",
    "plusbar_sport",
    "financial",
    "sustainability",
    "fieldmarketing",
    "commercial_conditions",
  ],
  // Defensa
  [ProposalTypeOfVisit.ClientDefense]: [
    "volumes",
    "product_card",
    "photo_success",
    "nexho",
    "commercial_conditions",
  ],
  // Traspaso
  [ProposalTypeOfVisit.Transfer]: [
    "catalog",
    "product_card",
    "waters",
    "nexho",
    "plusbar",
    "plusbar_sport",
    "financial",
    "sustainability",
    "fieldmarketing",
    "commercial_conditions",
  ],
};

export const allowOnlyIsNew = [
  ProposalTypeOfVisit.ClientDefense,
  ProposalTypeOfVisit.BusinessDevelopment,
];
